/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import {getStatus} from '@/api/deviceApi';
import * as APPDATA from '@/constants/pcConstAppData';
import {eventBusObject} from '@/observers/eventBus';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
}))
class VolumeSensorReadlines extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};

    this._bus = eventBusObject();
    this.successGetVolumeSensorReadlines = this.successGetVolumeSensorReadlines.bind(this);
  }

  componentDidMount() {
    this.eventVolumeSensorReadlines = this._bus.subscribe(VolumeSensorReadlinesEvent.VOLUME_SENSOR_READLINES, (param) =>
      this.volumeSensorReadlinesCheck(param),
    );
  }

  componentWillUnmount() {
    this.eventVolumeSensorReadlines.unsubscribe();
    this.clearLoopVolumeSensorReadlines();
  }

  clearLoopVolumeSensorReadlines = () => {
    if (this._getVolumeSensor === undefined) return;
    clearInterval(this._getVolumeSensor);
    this._getVolumeSensor = undefined;
  };

  volumeSensorReadlinesCheck = () => {
    this._isGetVolumeSensorCancled = false;
    const propsTubeAvailabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.VOLUME_SENSOR_READLINESS.WAITING_READY,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetVolumeMonitoring,
      },
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);

    this.getVolumeSensor();
  };

  getVolumeSensor = () => {
    this._getVolumeSensor = setInterval(async () => {
      if (this._isGetVolumeSensorCancled === true) {
        this.clearLoopVolumeSensorReadlines();
        return;
      }

      const response = await getStatus();

      this.successGetVolumeSensorReadlines(response);
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  };

  successGetVolumeSensorReadlines = (response) => {
    if (this._isTubeAvailabilityCancled === true) {
      this.clearLoopVolumeSensorReadlines();
      return;
    }
    const ProteinVolume = parseFloat(response.data.currentVolume);

    if (ProteinVolume !== 0) {
      this.actionVolumeSensorReady();
    }
  };

  actionVolumeSensorReady = () => {
    const {callbackVolumeSensorReady} = this.props;

    this.clearLoopVolumeSensorReadlines();
    callbackVolumeSensorReady();
  };

  updateMessageLoading = (props) => {
    const {dispatch} = this.props;

    dispatch(
      loadingActions.updateLoading({
        showLoading: props.showLoading,
        loadingText: props.loadingText,
        loadingButton1:
          props.loadingButton1 !== undefined
            ? {
                label: props.loadingButton1.label,
                onClick: props.loadingButton1.onClick,
              }
            : undefined,
      }),
    );
  };

  cancleResetVolumeMonitoring = () => {
    this.clearLoopVolumeSensorReadlines();
    this.closeLoading();
  };

  closeLoading = () => {
    const propsTubeAvailabilityCheck = {
      showLoading: undefined,
      loadingText: undefined,
      loadingButton1: undefined,
    };
    this.updateMessageLoading(propsTubeAvailabilityCheck);
  };

  render() {
    return null;
  }
}
export default VolumeSensorReadlines;

export const VolumeSensorReadlinesEvent = {
  VOLUME_SENSOR_READLINES: 'VOLUME_SENSOR_READLINES',
};
